(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["harmony-cart-drawer"]) return;
  try {
    
(() => {
  const drawer = document.getElementById('harmony-cart-drawer');
  if (!drawer || window.HarmonyCart) return;
  const status = drawer.querySelector('[data-hcd-status]');
  const fallback = drawer.querySelector('[data-hcd-fallback]');
  let busy = false;
  let cartChanged = false;
  let opener;
  const setBusy = (value) => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-hcd-step], [data-hcd-remove], [name="checkout"]').forEach(button => { button.disabled = value; });
  };
  const show = () => {
    if (!drawer.open) {
      opener = document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('hcd-open');
      drawer.querySelector('[data-hcd-close]').focus();
    }
  };
  const sync = async () => {
    const url = new URL(drawer.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', drawer.dataset.section);
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(drawer.dataset.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = html.querySelector('[data-hcd-content]');
    const count = html.querySelector('[data-hcd-count]');
    if (!fresh || !count) throw new Error(drawer.dataset.error);
    drawer.querySelector('[data-hcd-content]').replaceWith(fresh);
    drawer.querySelector('[data-hcd-count]').textContent = count.textContent;
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = Number(count.textContent) ? (node.closest('.mobile-cart-link') ? count.textContent : ` (${count.textContent})`) : '';
    });
    fallback.hidden = true;
  };
  const fail = (error) => {
    status.textContent = error.message || drawer.dataset.error;
    fallback.hidden = false;
  };
  const open = async () => {
    show();
    if (busy) return;
    setBusy(true);
    status.textContent = '';
    try { await sync(); } catch (error) { fail(error); } finally { setBusy(false); }
  };
  window.HarmonyCart = { open };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-discount-apply]');
    if (!button) return;
    const box = button.closest('[data-discount-box]');
    const input = box.querySelector('[data-discount-input]');
    const message = box.querySelector('[data-discount-status]');
    const code = input.value.trim();
    if (!code) { message.textContent = 'Enter a discount code.'; input.focus(); return; }
    const previousCode = box.dataset.appliedCode || '';
    button.disabled = true;
    message.textContent = 'Applying code…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const updateDiscount = async (discount) => {
        const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not apply that code.');
        return result;
      };
      let cart = await updateDiscount(code);
      cartChanged = true;
      const cartPage = await fetch(root + 'cart', {cache:'no-store'});
      if (!cartPage.ok) throw new Error('Could not confirm the discount. Please refresh the cart.');
      const rendered = new DOMParser().parseFromString(await cartPage.text(), 'text/html');
      const appliedCode = rendered.querySelector('.cart-page [data-discount-box]')?.dataset.appliedCode || '';
      if (appliedCode.toLowerCase() !== code.toLowerCase()) {
        const restorePrevious = previousCode && previousCode.toLowerCase() !== code.toLowerCase();
        if (restorePrevious) cart = await updateDiscount(previousCode);
        if (box.closest('#harmony-cart-drawer')) await sync();
        else {
          const subtotal = document.querySelector('[data-cart-subtotal]');
          if (subtotal) subtotal.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cart.total_price / 100);
          if (restorePrevious) box.dataset.appliedCode = previousCode;
          else delete box.dataset.appliedCode;
        }
        const currentBox = box.closest('#harmony-cart-drawer') ? drawer.querySelector('[data-discount-box]') : box;
        currentBox.querySelector('[data-discount-input]').value = restorePrevious ? previousCode : code;
        currentBox.querySelector('[data-discount-status]').textContent = restorePrevious ? 'Code not applied. ' + previousCode + ' remains active.' : 'Code not applied. Check the code and try again.';
        return;
      }
      if (box.closest('#harmony-cart-drawer')) {
        await sync();
        const freshBox = drawer.querySelector('[data-discount-box]');
        freshBox.querySelector('[data-discount-input]').value = code;
        freshBox.querySelector('[data-discount-status]').textContent = code.toUpperCase() + ' applied.';
      } else {
        box.dataset.appliedCode = code;
        const subtotal = document.querySelector('[data-cart-subtotal]');
        if (subtotal) {
          const currency = window.Shopify?.currency?.active || 'USD';
          subtotal.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cart.total_price / 100);
        }
        message.textContent = code.toUpperCase() + ' applied.';
      }
    } catch (error) { message.textContent = error.message || 'Could not apply that code.'; }
    finally { button.disabled = false; }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) { event.preventDefault(); event.target.closest('[data-discount-box]').querySelector('[data-discount-apply]').click(); }
  });
drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('hcd-open');
    if (opener?.isConnected) opener.focus();
    if (cartChanged && location.pathname.replace(/\/$/, '') === drawer.dataset.cartUrl.replace(/\/$/, '')) location.reload();
  });
  drawer.addEventListener('click', async (event) => {
    if (event.target === drawer || event.target.closest('[data-hcd-close]')) { drawer.close(); return; }
    const control = event.target.closest('[data-hcd-step], [data-hcd-remove]');
    if (!control || busy) return;
    const item = control.closest('[data-hcd-key]');
    const quantity = control.hasAttribute('data-hcd-remove') ? 0 : Number(item.dataset.hcdQuantity) + Number(control.dataset.hcdStep);
    const key = item.dataset.hcdKey;
    const step = control.dataset.hcdStep;
    setBusy(true);
    status.textContent = '';
    try {
      const response = await fetch(`${drawer.dataset.changeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      cartChanged = true;
      await sync();
      const line = Array.from(drawer.querySelectorAll('[data-hcd-key]')).find(node => node.dataset.hcdKey === key);
      setBusy(false);
      (line?.querySelector(`[data-hcd-step="${step}"]`) || drawer.querySelector('[data-hcd-close]')).focus();
    } catch (error) { fail(error); } finally { setBusy(false); }
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.cart-link, .mobile-cart-link');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    open();
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.purchase-box')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const body = new FormData(form);
    body.delete('return_to');
    if (!body.get('quantity')) body.set('quantity','1');
    const button = form.querySelector('[type="submit"]');
    const wasDisabled = button?.disabled;
    show();
    setBusy(true);
    status.textContent = '';
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${drawer.dataset.addUrl}.js`, {method:'POST',headers:{'Accept':'application/json'},body});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      cartChanged = true;
      await sync();
    } catch (error) { fail(error); } finally { setBusy(false); if (button) button.disabled = wasDisabled; }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
